module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "nav__btn",
    class: _vm.classes,
    attrs: {
      "to": {
        name: 'single-plant',
        params: {
          slug: _vm.slug
        }
      }
    }
  }, [_c('svg', {
    staticClass: "nav__arrow",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "54px",
      "height": "54px"
    },
    on: {
      "click": function($event) {
        _vm.pushTheButton()
      },
      "mouseenter": function($event) {
        _vm.onMouseEnter()
      },
      "touchstart": function($event) {
        _vm.onMouseEnter()
      },
      "mouseleave": function($event) {
        _vm.onMouseLeave()
      },
      "touchend": function($event) {
        _vm.onMouseLeave()
      }
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "filterUnits": "userSpaceOnUse",
      "id": "Filter_0",
      "x": "0px",
      "y": "0px",
      "width": "54px",
      "height": "54px"
    }
  }, [_c('feOffset', {
    attrs: {
      "in": "SourceAlpha",
      "dx": "0",
      "dy": "0"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "result": "blurOut",
      "stdDeviation": "3"
    }
  }), _vm._v(" "), _c('feFlood', {
    attrs: {
      "flood-color": "rgb(0, 0, 0)",
      "result": "floodOut"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "operator": "atop",
      "in": "floodOut",
      "in2": "blurOut"
    }
  }), _vm._v(" "), _c('feComponentTransfer', [_c('feFuncA', {
    attrs: {
      "type": "linear",
      "slope": "0.26"
    }
  })], 1), _vm._v(" "), _c('feMerge', [_c('feMergeNode'), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1)], 1)]), _vm._v(" "), _c('path', {
    staticClass: "circle-shadow",
    attrs: {
      "filter": "url(#Filter_0)",
      "fill-rule": "evenodd",
      "fill": "rgb(255, 255, 255)",
      "d": "M26.000,10.500 C34.837,10.500 42.000,17.663 42.000,26.500 C42.000,35.337 34.837,42.500 26.000,42.500 C17.163,42.500 10.000,35.337 10.000,26.500 C10.000,17.663 17.163,10.500 26.000,10.500 Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "circle",
    attrs: {
      "fill-rule": "evenodd",
      "fill": "rgb(255, 255, 255)",
      "d": "M26.000,10.500 C34.837,10.500 42.000,17.663 42.000,26.500 C42.000,35.337 34.837,42.500 26.000,42.500 C17.163,42.500 10.000,35.337 10.000,26.500 C10.000,17.663 17.163,10.500 26.000,10.500 Z"
    }
  }), _vm._v(" "), (_vm.direction == 'prev') ? _c('g', {
    staticClass: "arrow",
    attrs: {
      "transform": "translate(20,18)"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "fill": "rgb(197, 195, 176)",
      "d": "M7.895,16.192 L0.495,9.000 L7.895,1.808 C8.463,2.235 8.984,2.720 9.437,3.266 L3.537,9.000 L9.437,14.734 C8.984,15.280 8.463,15.765 7.895,16.192 Z"
    }
  })]) : _c('g', {
    staticClass: "arrow",
    attrs: {
      "transform": "translate(21,18)"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "fill": "rgb(197, 195, 176)",
      "d": "M3.605,1.808 L11.005,9.000 L3.605,16.192 C3.037,15.765 2.516,15.280 2.063,14.734 L7.963,9.000 L2.063,3.266 C2.516,2.720 3.037,2.235 3.605,1.808 Z"
    }
  })])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-26d8f858!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UI/NavigationButton.vue
 ** module id = 749
 ** module chunks = 2
 **/